import { MdsIcon } from '@mds/icons';

export enum DataCollectionTabValues {
  CAMPAIGNS = 'campaigns',
  REQUESTS = 'requests'
}

export const DataCollectionTabs = [
  {
    value: DataCollectionTabValues.CAMPAIGNS,
    icon: MdsIcon.CAMPAIGNS,
    label: 'Campaigns',
    disabled: false,
    ariaLabel: 'Campaigns'
  },
  {
    value: DataCollectionTabValues.REQUESTS,
    icon: MdsIcon.REQUESTS,
    label: 'Requests',
    disabled: false,
    ariaLabel: 'Requests'
  }
];

export enum CampaignTabsEnum {
  QUESTIONNAIRES = 'questionnaires',
  HISTORY = 'history'
}
